import React, { useEffect, useState } from 'react';
import Table from 'react-bootstrap/Table'
import { toDateFormat } from 'utils/date';
import _ from 'lodash';
import Moment from 'moment'



const SeriesTable = ({ tableTitle, exercises, workout, series, setTableTemp, table, ...props}) => {
  const [formattedExercises, setFormattedExercises] = useState([])

  useEffect(() => {
    let test = formatData(exercises);
    setFormattedExercises([...test])

    let flatExercises = {}
    test.map((exercise, i) => {
      Object.keys(exercise).forEach(key => {
        if(key === 'uniqueId') {}
        else {
          flatExercises[`${key} for exercise ${i+1}`] = exercise[key]
        }
      })
      return flatExercises
    })
    setTableTemp({
      workout: workout,
      series: series,
      ...flatExercises
    })
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [exercises, series])

  return (
    <div className="series-table">
      <div className="table-title">{tableTitle}</div>
      <Table>
        <thead>
          <tr>
            <th>DATE</th>
            <th># OF SETS</th>
            <th>TEMPO</th>
            <th>TUT</th>
            <th>MAX LIFT (KG)</th>
            <th>SET REPS</th>
            <th>SET VOLUME</th>
            <th>SET WORK (MIN)</th>
            <th>SET TIME (MIN)</th>
          </tr>
        </thead>
        <tbody>
          {
            formattedExercises.map((exercise) => {
              return (
                <tr key={exercise.uniqueId}>
                  <td>{exercise.date}</td>
                  <td>{exercise['num of sets']}</td>
                  <td>{exercise.tempo}</td>
                  <td>{exercise.tut}</td>
                  <td>{exercise['max lift']}</td>
                  <td>{exercise.reps}</td>
                  <td>{exercise.volume}</td>
                  <td>{exercise['set work']}</td>
                  <td>{exercise['set time']}</td>
                </tr>
              )
            })
          }
        </tbody>
      </Table>
    </div>
  );
}

const formatData = (data) => {
  const groupedById = _.groupBy(data, 'id')
  const exercises = []
  const groupedByIdKeys = Object.keys(groupedById)
  groupedByIdKeys.forEach((logId, i) => {
    let log = getRowFromList(groupedById[logId])
    log.uniqueId = logId+i
    exercises.push(log)
  })
  return exercises
}

const getRowFromList = (exercises) => {
  let tut = []
  let maxLift = 0
  let reps = 0
  let volume = 0
  let row = {}
  let rest = 0
  row.tut = 0

  exercises.forEach((log) => {
    row.date = Moment(toDateFormat(log.date)).format('DD/MM/YYYY')
    tut.push(calculateTut(log.tempo, log.reps))
    if(log.weight > maxLift) maxLift = log.weight
    reps += log.reps
    volume += (log.reps * log.weight)
    rest += log.rest
  })

  row['num of sets'] = exercises.length
  row['max lift'] = maxLift
  row.reps = reps
  row.volume = volume
  row.tut = tut.reduce((a, b) => a + b, 0)
  row.tempo = exercises[0].tempo
  row['set work'] = round(row.tut / 60)
  row['set time'] = round((row.tut + rest) / 60)
  return row
}

const calculateTut = (tempo, reps) => {
  const tempoString = Array.from(tempo.toString())
  let tut = 0
  tempoString.forEach(temp => {tut = tut + parseInt(temp)})
  return tut * reps
}

const round = (number) => {
 return Math.round((number + Number.EPSILON) * 100) / 100
}

export default SeriesTable;
